import { faGift } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

export const StampcardRewardBanner = () => {
  return (
    <div className="flex w-full items-center gap-6 rounded-3xl bg-kiosk-accent-secondary/50 p-8">
      <FontAwesomeIcon icon={faGift} size="2x" />
      <div>
        <p className="text-4xl font-bold text-kiosk-text-primary">
          <T _str="Reward claimed" />
        </p>
        <p className="text-2xl text-kiosk-text-primary">
          <T _str="Your reward is now ready, simply place the products in the basket" />
        </p>
      </div>
    </div>
  );
};
